import { useMemo } from "react";
import { Wizard } from "../common/wizard/wizard";
import { useParticipantProfile } from "../shared/hooks/useParticipantProfile";
import { onboardingStyles } from "./onboarding.styles";
import { renderSteps } from "./onboardingSteps";
import { steps } from "./steps";

export const Onboarding = () => {
  const classes = onboardingStyles();
  const { isPasswordCreated, participantProfileId } = useParticipantProfile();

  const wizardSteps = useMemo(() => {
    if (participantProfileId && isPasswordCreated) {
      return [...steps];
    }

    return steps;
  }, [isPasswordCreated, participantProfileId]);

  return (
    <div className={classes.container}>
      <Wizard renderSteps={renderSteps} steps={wizardSteps} />
    </div>
  );
};
